import React, { useState } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Paiements.css';
import { useNavigate } from 'react-router-dom';

// Icônes
import { 
    FaCreditCard, 
    FaCheckCircle, 
    FaTimesCircle,
    FaEuroSign,
    FaGraduationCap,
    FaChalkboardTeacher,
    FaCertificate,
    FaHeadset,
    FaFileAlt,
    FaVideo,
    FaUserTie,
    FaChartLine,
    FaLock,
    FaShieldAlt,
    FaQuestionCircle,
    FaInfoCircle,
    FaExclamationTriangle,
    FaArrowRight,
    FaFlag
} from 'react-icons/fa';

const Paiements = () => {
    const navigate = useNavigate();
    const [offreSelectionnee, setOffreSelectionnee] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    // Liens Stripe pour les paiements
    const liensPaiement = {
        etudeDossier: 'https://buy.stripe.com/bJe8wPh1rgOidB12El3wQ00',
        standard: 'https://buy.stripe.com/6oU00j7qRfKegNdceV3wQ02',
        premium: 'https://buy.stripe.com/bJecN5fXn8hMcwX5Qx3wQ01',
        personnalise: 'https://buy.stripe.com/fZufZhfXnapUbsT92J3wQ03'
    };

    // Redirection vers la page Côte d'Ivoire
    const handleCoteIvoireClick = () => {
        navigate('/paiements-cote-ivoire');
    };

    // Offres disponibles
    const offres = [
        {
            id: 'etudeDossier',
            nom: 'Étude de Dossier',
            prix: 50,
            devise: '€',
            lien: liensPaiement.etudeDossier,
            icon: FaFileAlt,
            description: 'Analyse complète de votre dossier académique',
            features: [
                'Analyse détaillée du dossier scolaire',
                'Évaluation des chances d\'admission',
                'Conseils personnalisés',
                'Feedback sur votre CV',
                'Recommandations d\'amélioration',
                'Délai de réponse : 72h'
            ]
        },
        {
            id: 'standard',
            nom: 'Offre Standard',
            prix: 100,
            devise: '€',
            lien: liensPaiement.standard,
            icon: FaGraduationCap,
            description: 'Accompagnement complet pour votre orientation',
            features: [
                'Tout de l\'offre Étude de Dossier',
                'Accompagnement personnalisé',
                'Aide à la rédaction de lettres de motivation',
                'Préparation aux entretiens',
                'Suivi hebdomadaire',
                'Accès aux webinaires exclusifs'
            ]
        },
        {
            id: 'premium',
            nom: 'Offre Premium',
            prix: 500,
            devise: '€',
            lien: liensPaiement.premium,
            icon: FaCertificate,
            description: 'Accompagnement VIP vers la réussite',
            features: [
                'Tout de l\'offre Standard',
                'Accompagnement illimité',
                'Simulations d\'entretiens',
                'Aide à la recherche de logement',
                'Assistance pour les démarches visa',
                'Support prioritaire 7j/7',
                'Coaching individuel',
                'Garantie satisfaction'
            ],
            populaire: true
        },
        {
            id: 'personnalise',
            nom: 'Offre Personnalisée',
            prix: null,
            devise: '€',
            lien: liensPaiement.personnalise,
            icon: FaEuroSign,
            description: 'Vous pouvez librement choisir le montant de votre contribution sur Stripe',
            personnalisable: true,
            features: [
                'Soutenez notre mission éducative',
                'Contribution à votre convenance',
                'Accompagnement adapté à vos besoins',
                'Contact personnalisé avec notre équipe',
                'Suivi dédié selon votre investissement',
                'Possibilité de payer en plusieurs fois'
            ]
        }
    ];

    const handlePaiement = (offre) => {
        setOffreSelectionnee(offre);
        
        // Redirection directe vers Stripe
        window.open(offre.lien, '_blank');
        
        setShowModal(true);
    };

    const fermerModal = () => {
        setShowModal(false);
        setOffreSelectionnee(null);
    };

    return (
        <div className="paiements-section">
            <Header />
            
            <div className="paiements-container">
                {/* Bannière stylée */}
                <div className="paiements-banner">
                    <div className="banner-pattern"></div>
                    
                    {/* Éléments décoratifs */}
                    <div className="banner-decoration">
                        <div className="deco-circle deco-circle-1"></div>
                        <div className="deco-circle deco-circle-2"></div>
                        <div className="deco-line deco-line-1"></div>
                        <div className="deco-line deco-line-2"></div>
                    </div>
                    
                    <div className="banner-content">
                        <FaCreditCard className="banner-icon" />
                        <h1 className="banner-title">
                            Nos <span>Offres de Paiement</span>
                        </h1>
                        <p className="banner-subtitle">
                            Choisissez l'offre qui correspond le mieux à vos besoins pour votre projet d'études en France
                        </p>
                        
                        {/* Badges de confiance */}
                        <div className="banner-trust">
                            <div className="trust-item">
                                <FaShieldAlt />
                                <span>Paiement 100% sécurisé</span>
                            </div>
                            <div className="trust-item">
                                <FaCheckCircle />
                                <span>Satisfaction garantie</span>
                            </div>
                            <div className="trust-item">
                                <FaHeadset />
                                <span>Support 7j/7</span>
                            </div>
                        </div>

                        {/* Bouton Côte d'Ivoire */}
                        <div className="banner-ci-button-container">
                            <button 
                                className="btn-cote-ivoire"
                                onClick={handleCoteIvoireClick}
                            >
                                <FaFlag className="ci-flag-icon" />
                                <span>Étudiants de Côte d'Ivoire</span>
                                <FaArrowRight className="ci-arrow-icon" />
                                <div className="ci-flag-colors">
                                    <span className="ci-color-orange"></span>
                                    <span className="ci-color-white"></span>
                                    <span className="ci-color-green"></span>
                                </div>
                            </button>
                            <p className="ci-hint">
                                Offres spéciales pour les étudiants ivoiriens
                            </p>
                        </div>
                    </div>
                </div>

                {/* Grille des offres */}
                <div className="offres-grid">
                    {offres.map((offre) => (
                        <div 
                            key={offre.id} 
                            className={`offre-card ${offre.populaire ? 'premium' : ''} ${offre.personnalisable ? 'personnalisable' : ''}`}
                        >
                            {offre.populaire && (
                                <span className="popular-badge">
                                    <FaCheckCircle /> Recommandé
                                </span>
                            )}
                            
                            <div className="offre-header">
                                <offre.icon className="offre-icon" />
                                <h2>{offre.nom}</h2>
                                <div className="offre-prix">
                                    {offre.prix ? (
                                        <>
                                            <span className="currency">{offre.devise}</span>
                                            {offre.prix}
                                        </>
                                    ) : (
                                        <span>Montant libre</span>
                                    )}
                                </div>
                            </div>
                            
                            <div className="offre-body">
                                <p className="offre-description">{offre.description}</p>
                                
                                <ul className="offre-features">
                                    {offre.features.map((feature, index) => (
                                        <li key={index}>
                                            <FaCheckCircle className="feature-icon" />
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                                
                                <button 
                                    className="btn-payer"
                                    onClick={() => handlePaiement(offre)}
                                >
                                    <FaCreditCard />
                                    {offre.prix ? `Payer ${offre.prix} €` : 'Choisir mon montant sur Stripe'}
                                    <FaArrowRight />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Section d'information */}
                <div className="paiements-info">
                    <h3 className="info-title">
                        <FaInfoCircle />
                        Informations importantes
                    </h3>
                    
                    <div className="info-content">
                        <div className="info-block">
                            <h4>
                                <FaShieldAlt />
                                Paiement sécurisé
                            </h4>
                            <p>
                                Tous les paiements sont traités de manière sécurisée via Stripe, 
                                leader mondial des paiements en ligne. Vos informations bancaires 
                                sont cryptées et jamais stockées sur nos serveurs.
                            </p>
                        </div>
                        
                        <div className="info-block">
                            <h4>
                                <FaLock />
                                Garantie et remboursement
                            </h4>
                            <p>
                                • Délai de rétractation de 14 jours<br />
                                • Remboursement intégral si votre dossier n'est pas traité<br />
                                • Service client disponible 7j/7
                            </p>
                        </div>
                        
                        <div className="info-block">
                            <h4>
                                <FaQuestionCircle />
                                Questions fréquentes
                            </h4>
                            <ul>
                                <li>
                                    <FaCheckCircle />
                                    Puis-je payer en plusieurs fois ? Contactez-nous
                                </li>
                                <li>
                                    <FaCheckCircle />
                                    Les offres sont-elles remboursables ? Oui, sous conditions
                                </li>
                                <li>
                                    <FaCheckCircle />
                                    Comment se passe l'accompagnement ? En visioconférence
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de confirmation */}
            {showModal && offreSelectionnee && (
                <div className="modal-overlay" onClick={fermerModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={fermerModal}>
                            <FaTimesCircle />
                        </button>
                        
                        <div className="modal-icon">
                            <FaCheckCircle />
                        </div>
                        
                        <h3>Paiement initié !</h3>
                        
                        <p>
                            Vous allez être redirigé vers la plateforme de paiement sécurisée Stripe.
                            {offreSelectionnee.prix === null && (
                                <><br /><strong>Pour l'offre personnalisée, vous pourrez choisir librement votre montant sur Stripe.</strong></>
                            )}
                        </p>
                        
                        <div className="modal-details">
                            <p>
                                <strong>Offre :</strong> {offreSelectionnee.nom}<br />
                                <strong>Montant :</strong> {offreSelectionnee.prix 
                                    ? `${offreSelectionnee.prix} €` 
                                    : 'À définir sur Stripe'}
                            </p>
                        </div>
                        
                        <button className="modal-btn" onClick={fermerModal}>
                            J'ai compris
                        </button>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default Paiements;